export default "__VITE_ASSET__DLjff0SF__"